import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import Icon from "../common/icon/icon.component.jsx"
import GlobalHelper from "../common/GlobalHelper.jsx";

class TemplateListing extends Component {

    constructor(props, context) {
        super(props, context)

        const account = AppContext.getAccount();
        const accountLanguages = [
            'none',
            account.attributes.defaultLanguage.substring(0, 2),
            ...account.attributes.additionalLanguages
        ];

        this.state = {
            rows: [],
            headers: [],
            loading: false,
            documentType: this.props.match.params.documentType,
            accountLanguages,
            defaultTemplatesCount: 1,
            lastUpdatedTemplate: null,
        }

        this.setLanguage = this.setLanguage.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        this.refreshSearch()
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/documents/templates/' + this.state.documentType).then(r => {
            const defaultTemplatesCount = r.data.filter(row => row.attributes.status === "default").length;
            this.setState({
                defaultTemplatesCount
            })

            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => {
                    if (this.state.lastUpdatedTemplate && q.id === this.state.lastUpdatedTemplate.id)
                        return this.row(this.state.lastUpdatedTemplate)
                    else
                        return this.row(q)
                }),
                loading: false,
            })
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="templates.list.headers.name_label"
                defaultMessage="Name"
            />,
            <FormattedMessage
                id="templates.list.headers.status_label"
                defaultMessage="Status"
            />,
            '',
        ]
    }

    setDefault(documentId) {
        return function (e) {
            e.preventDefault()
            AppContext.getApiClient().put('/documents/' + documentId + '/default').then(r => {
                this.setState({
                    lastUpdatedTemplate: r,
                })
                this.refreshSearch()
            })
        }.bind(this)
    }

    setLanguage(e, documentId, language) {
        e.preventDefault()
        language = (language === 'none') ? '' : language;
        const update = {
            language
        }
        AppContext.getApiClient().patch('/documents/' + documentId, update).then(r => {
            this.setState({
                lastUpdatedTemplate: r,
            })
            this.refreshSearch()
        })
    }

    setEnabled(documentId) {
        const update = {
            status: "enabled"
        }
        return function (e) {
            e.preventDefault()
            AppContext.getApiClient().patch('/documents/' + documentId, update).then((r) => {
                this.setState({
                    lastUpdatedTemplate: r,
                })
                this.refreshSearch();
            })
        }.bind(this)
    }

    row(item) {
        let status = ''
        let defaultBtn = ''
        let language = item.attributes.language ? item.attributes.language.substring(0, 2) : '';

        let accountLanguages = this.state.accountLanguages.filter(lang => lang !== language)
        if (!language) {
            accountLanguages = accountLanguages.filter(lang => lang !== 'none')
        }

        let languagesDropdown =
            (accountLanguages.length > 1 && ["quote-template",
                "invoice-template",
                "account-statement-template",
                "packing-slip-template"].includes(this.state.documentType)) ?
                <span className="dropdown ml-2">
                    <button className="btn btn-sm btn-outline-primary dropdown-toggle" type="button"
                        id="languagesDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <FormattedMessage
                            id="templates.list.language_label"
                            defaultMessage="Language"
                        />
                    </button>
                    <div className="dropdown-menu" aria-labelledby="languagesDropdown">
                        {accountLanguages.map(language => {
                            return <a className="dropdown-item" href="#" value={language} key={language}
                                onClick={(e) => {
                                    this.setLanguage(e, item.id, language)
                                }}>
                                {this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(language))}
                            </a>
                        })}
                    </div>
                </span> : ''

        switch (item.attributes.status) {
            case "enabled":
                status = <div>
                    <div className="badge badge-primary">
                        <FormattedMessage
                            id="templates.list.status.enabled_label"
                            defaultMessage="Enabled"
                        />
                    </div>
                    {language && <div className="badge badge-dark ml-2">
                        {this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(language))}
                    </div>}
                </div>
                if ([
                    "price-list-template",
                    "quote-template",
                    "invoice-template",
                    "account-statement-template",
                    "packing-slip-template",
                    "order-template",
                    "contract-template",
                    "scheduling-page-template",
                    "credit-memo-template",
                    "sms-quote-templates",
                ].includes(this.state.documentType)) {
                    defaultBtn = <button onClick={this.setDefault(item.id)} className="btn btn-sm btn-outline-primary ml-2">
                        <FormattedMessage
                            id="templates.list.headers.set_default_btn"
                            defaultMessage="Default"
                        />
                    </button>
                }
                break
            case "disabled":
                status = <div>
                    <div className="badge badge-secondary">
                        <FormattedMessage
                            id="templates.list.status.disabled_label"
                            defaultMessage="Disabled"
                        />
                    </div>
                </div>
                languagesDropdown = ''
                break
            case "default":
                status = <div>
                    <div className="badge badge-info">
                        <FormattedMessage
                            id="templates.list.status.default_label"
                            defaultMessage="Default"
                        />
                    </div>
                    {language && <div className="badge badge-dark ml-2">
                        {this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(language))}
                    </div>}
                </div>
                break
        }

        return [
            <Link to={"/templates/" + item.id + "/edit"}>{item.attributes.name}</Link>,
            status,
            <div>
                <Link to={"/templates/" + item.id + "/sections/preview"} className="btn btn-sm btn-outline-primary">
                    <FormattedMessage
                        id="templates.list.headers.edit_sections_btn"
                        defaultMessage="Edit sections"
                    />
                </Link>
                {defaultBtn}
                {languagesDropdown}
            </div>,
        ]
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }
        let addButtonName = ''
        switch (this.state.documentType) {
            case "account-statement-template":
            case "invoice-template":
            case "packing-slip-template":
            case "price-list-template":
            case "quote-template":
            case "order-template":
            case "contract-template":
            case "scheduling-page-template":
            case "credit-memo-template":
                addButtonName = <FormattedMessage
                    id="templates.list.add_template_btn"
                    defaultMessage="Add Template"
                />
                break
            case "snippet":
                addButtonName = <FormattedMessage
                    id="templates.list.add_snippet_btn"
                    defaultMessage="Add snippet"
                />
                break
        }
        return (
            <div>
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-9">
                                <Link to={"/branding"} className="btn btn-light">
                                    <Icon value={"chevron-left"} />
                                    <FormattedMessage
                                        id="templates.list.back_btn"
                                        defaultMessage="Back to branding"
                                    />
                                </Link>
                            </div>
                            <div className="col-3 text-align-right ">
                                <Link to={"/templates/" + this.state.documentType + "/new"} className="btn btn-primary">
                                    <Icon value={"plus-circle"} />
                                    {addButtonName}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default injectIntl(TemplateListing)


// WEBPACK FOOTER //
// ./src/template/listing.component.jsx